<template>
  <div class="ai bg-white">
    <ai-alert v-if="showTerms" @close="showTerms = false"></ai-alert>
    <template v-else>
      <header class="f-b-c">
        <div class="left f--c">
          <img class="logo pointer" src="@/assets/img/logo.png" @click="jump" />
          <div class="logo-ai">
            <img class="pointer" src="https://img.kakaclo.com/web-img/home/ai/logo_ai3.png" @click="initAi('back')" />
          </div>
        </div>
        <div class="right f--c">
          <el-tooltip class="item" effect="dark" content="Terms Of Use" placement="bottom">
            <img class="warning pointer" src="https://img.kakaclo.com/web-img/home/ai/warning.png" @click="showTerms = true" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="isHistory?'Back To Ai':'History Record'" placement="bottom">
            <img v-if="isHistory" class="time pointer" src="https://img.kakaclo.com/web-img/home/ai/back.png" @click="initAi('back')" />
            <img v-else class="time pointer" src="https://img.kakaclo.com/web-img/home/ai/time.png" @click="handleHistory" />
          </el-tooltip>
          <div class="user f--c">
            <div class="avatar f-c-c">{{ firstName }}</div>
            <div class="name">{{ $store.state.common.userName }}</div>
          </div>
        </div>
      </header>
      <div class="content f--c">
        <div v-if="!isHistory" class="filtration-options">
          <div class="slider">
            <div class="options">
              <div class="head">
                <div class="title">
                  <i>*</i> Image
                </div>
              </div>
              <div class="block">
                <div class="img f-c-c">
                  <photograph :isCompress="false" :page="'ai'" @uploadSuccess="uploadSuccess">
                    <div class="imgUrl" v-if="param.initImages">
                      <oss-img :width="320" :height="320" :src="param.initImages" mType="pad" />
                    </div>
                    <div v-else class="upload f-c-c fd-c">
                      <img src="https://img.kakaclo.com/web-img/home/ai/icon_add.png" alt="">
                      <div>Click to upload, or drag and</div>
                      <div>drop images here</div>
                    </div>
                  </photograph>
                </div>
                <div class="hint gray">
                  Please upload a clear picture of the clothes.
                </div>
              </div>
            </div>
            <div class="options">
              <div class="head f-b-c">
                <div class="title">
                  Image count
                </div>
                <div>{{ imageCount }}</div>
              </div>
              <div class="block">
                <el-slider
                  v-model="imageCount"
                  :step="1"
                  :min="1"
                  :max="4">
                </el-slider>
              </div>
            </div>
            <div class="options">
              <div class="head f-b-c">
                <div class="title">
                  Denoising strength
                </div>
                <!-- <div>{{ denoisingStrength }}</div> -->
              </div>
              <div class="block">
                <!-- <el-slider
                  v-model="denoisingStrength"
                  :step="1"
                  :max="100">
                </el-slider> -->
                <el-radio-group v-model="denoisingStrength" size="mini">
                  <el-radio :label="50" border>Minor changes</el-radio>
                  <el-radio :label="56" border>Moderate changes</el-radio>
                  <el-radio :label="62" border>Major changes</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="options">
              <div class="head">
                <div class="title">
                  <i>*</i> Category
                </div>
              </div>
              <div class="block">
                <el-select v-model="categoryVal" placeholder="select" size="mini" class="select" @change="categoryChange">
                  <el-option
                    v-for="item in categoryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item title="Prompt01" name="1" class="options">
                <div class="block" v-if="categorySel">
                  <template v-for="item in prompt01" >
                    <el-select v-if="categorySel.ids.includes(item.id)" :key="item.name" v-model="item.value" clearable :placeholder="item.name" size="mini" class="select">
                      <el-option
                        v-for="t in item.list"
                        :key="t.value"
                        :label="t.label"
                        :value="t.value">
                      </el-option>
                    </el-select>
                  </template>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Prompt02" name="2" class="options">
                <div class="block">
                  <el-input type="textarea" v-model="prompt02" placeholder="Please input" :rows="5"></el-input>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Seed" name="3" class="options">
                <el-input v-model="seed" placeholder="Seed Auto" :maxlength="15" size="mini" class="input" @input="handleInput"></el-input>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="options-foot bg-white">
            <el-button :loading="aiTaskLength === aiTaskList.length" type="primary" :disabled="aiTaskLength === aiTaskList.length" class="foot-btn" @click="generate">Generate Image</el-button>
          </div>
        </div>
        <div ref="aiMain" class="main">
          <div v-if="toolTip" class="alert f-c-c">
            <div>
              <i class="el-icon-info"></i>
              Please read the <span class="green" @click="showTerms = true">Terms of Use</span> before using Kaka AI.
            </div>
            <i class="el-icon-close pointer" @click="toolTip = false"></i>
          </div>
          <div v-if="(isRequest || aiTaskList.length) && !isHistory" class="main-img" :style="{ height: toolTip ? 'calc(100vh - 100px)' : 'calc(100vh - 64px)' }">
            <template v-for="item in aiTaskList">
              <ai-task :key="item.taskId" :isHistory="isHistory" :aiData="aiData" :aiTask="item" @handleDelete="handleDelete" @handleCancel="handleCancel" />
            </template>
          </div>
          <div v-else-if="historyList.length && isHistory" class="main-img" :style="{ height: toolTip ? 'calc(100vh - 100px)' : 'calc(100vh - 64px)' }">
            <template v-for="item in historyList">
              <ai-task :key="item.taskId" :isHistory="isHistory" :aiData="aiData" :aiTask="item" @handleDelete="handleDelete" @handleCancel="handleCancel" />
            </template>
          </div>
          <div v-else class="empty f-c-c">
            <img src="https://img.kakaclo.com/web-img/home/ai/empty.png" alt="">
            <!-- <el-button class="btn">Upload Reference Image</el-button> -->
            <photograph :isCompress="false" :page="'ai'" @uploadSuccess="uploadSuccess">
              <el-button class="btn">Upload Reference Image</el-button>
            </photograph>
            <div class="gray">Click to upload, or drag and drop images here</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import OssImg from '@/components/OssImg.vue'
import Photograph from '../../index/components/Photograph.vue'
import _ from 'lodash'
import API from '@/api'
import { guid } from '@/util/uuid'
import AiTask from './components/AiTask.vue'
import AiAlert from './components/AiAlert.vue'
import axios from '@/util/request'
let timer = null

export default {
  components: { Photograph, OssImg, AiTask, AiAlert },
  data() {
    return {
      imageCount: 1,
      denoisingStrength: 50,
      categoryVal: 'Clothing',
      categorySel: {
        value: 'Clothing',
        label: 'Clothing',
        ids: [1, 2, 3, 4, 5, 6, 7]
      },
      categoryList: [
        // { value: 'Top wear', label: 'Top wear', ids: [1, 2, 3, 4, 5, 6] },
        // { value: 'Bottom wear', label: 'Bottom wear', ids: [1, 2, 3, 4, 5] },
        // { value: 'Out wear', label: 'Out wear', ids: [1, 2, 3, 4] },
        // { value: 'Dress', label: 'Dress', ids: [1, 2, 3, 4, 5, 6, 7] },
        // { value: 'Suit', label: 'Suit', ids: [1, 2, 3, 4, 5, 6, 7] }
        { value: 'Clothing', label: 'Clothing', ids: [1, 2, 3, 4, 5, 6] },
        { value: 'Dress', label: 'Dress', ids: [1, 2, 3, 4, 5, 6] },
        { value: 'Outerwear', label: 'Outerwear', ids: [1, 2, 3, 4, 5, 6] }
      ],
      prompt01: [
        {
          name: 'Select color',
          id: 1,
          value: undefined,
          list: [
            { value: 'Black', label: 'Black' },
            { value: 'White', label: 'White' },
            { value: 'Gray', label: 'Gray' },
            { value: 'Red', label: 'Red' },
            { value: 'Orange', label: 'Orange' },
            { value: 'Yellow', label: 'Yellow' },
            { value: 'Blue', label: 'Blue' },
            { value: 'Purple', label: 'Purple' },
            { value: 'pink', label: 'pink' }
          ]
        },
        {
          name: 'Select pattern',
          id: 2,
          value: undefined,
          list: [
            { value: 'Floral print ', label: 'Floral print ' },
            { value: 'Stripe', label: 'Stripe' },
            { value: 'Polka dot', label: 'Polka dot' },
            { value: 'Lattice', label: 'Lattice' }
          ]
        },
        {
          name: 'Select material',
          id: 3,
          value: undefined,
          list: [
            { value: 'Cotton', label: 'Cotton' },
            { value: 'Modal', label: 'Modal' },
            { value: 'Linen', label: 'Linen' },
            { value: 'Silk', label: 'Silk' }
          ]
        },
        {
          name: 'Select style',
          id: 4,
          value: undefined,
          list: [
            { value: 'Sweet', label: 'Sweet' },
            { value: 'Sexy', label: 'Sexy' },
            { value: 'Cute', label: 'Cute' },
            { value: 'Elegant', label: 'Elegant' }
          ]
        },
        {
          name: 'Select neckline',
          id: 5,
          value: undefined,
          list: [
            { value: 'V neck', label: 'V neck' },
            { value: 'Round neck', label: 'Round neck' },
            // { value: 'The neck', label: 'The neck' },
            { value: 'Polo', label: 'Polo' }
          ]
        },
        {
          name: 'Select sleeve length',
          id: 6,
          value: undefined,
          list: [
            { value: 'Sleeveless', label: 'Sleeveless' },
            { value: 'Short sleeve', label: 'Short sleeve' },
            { value: 'Long sleeve', label: 'Long sleeve' },
            { value: 'Half sleeve', label: 'Half sleeve' }
          ]
        }
        // {
        //   name: 'Select length',
        //   id: 7,
        //   value: undefined,
        //   list: [
        //     { value: 'Short', label: 'Short' },
        //     { value: 'Knee length', label: 'Knee length' },
        //     { value: 'Midi', label: 'Midi' },
        //     { value: 'Long', label: 'Long' }
        //   ]
        // }
      ],
      prompt02: undefined,
      seed: undefined,
      activeNames: [],
      toolTip: true,
      showTerms: false, // 条款弹窗
      isRequest: false, // 是否加载
      isHistory: false, // 是否为查看历史
      isCancelTask: false, // 是否取消任务
      param: { // 作图参数
        initImages: undefined,
        denoisingStrength: undefined,
        prompt: undefined,
        seed: undefined,
        batchSize: undefined,
        width: 500,
        height: 500
      },
      taskId: '', // 任务id
      aiData: { // ai绘图数据
      },
      aiTaskList: [ // ai任务列表
        {
          taskId: '',
          status: '', // In Progress:生成中, In Waiting：等待中, In Complete:完成
          createDate: 1689218178122,
          queue: '', // 队列个数
          estimateTime: '', // 预估剩余时间（秒）
          images: [
            // {
            //   pngInfo: {
            //     seed: '111111111111111',
            //     size: '512x512',
            //     model: 'chilloutmix_NiPrunedFp32Fix',
            //     steps: null,
            //     sampler: 'Euler',
            //     version: 'v1.4.0',
            //     cfgScale: 7,
            //     modelHash: 'fc2511737a',
            //     seedResizeFrom: '-1x-1',
            //     denoisingStrength: 0.75
            //   },
            //   oosImgName: 'ai/ai_QGPaDJWg.png',
            //   oosUrl: 'https://img.kakaclo.com/ai/ai_QGPaDJWg.png',
            //   guid: guid()
            // },
            // {
            //   pngInfo: {
            //     seed: '111111111111111',
            //     size: '512x512',
            //     model: 'chilloutmix_NiPrunedFp32Fix',
            //     steps: null,
            //     sampler: 'Euler',
            //     version: 'v1.4.0',
            //     cfgScale: 7,
            //     modelHash: 'fc2511737a',
            //     seedResizeFrom: '-1x-1',
            //     denoisingStrength: 0.75
            //   },
            //   oosImgName: 'ai/ai_QGPaDJWg.png',
            //   oosUrl: 'https://img.kakaclo.com/ai/ai_QGPaDJWg.png',
            //   guid: guid()
            // },
            // {
            //   pngInfo: {
            //     seed: '111111111111111',
            //     size: '512x512',
            //     model: 'chilloutmix_NiPrunedFp32Fix',
            //     steps: null,
            //     sampler: 'Euler',
            //     version: 'v1.4.0',
            //     cfgScale: 7,
            //     modelHash: 'fc2511737a',
            //     seedResizeFrom: '-1x-1',
            //     denoisingStrength: 0.75
            //   },
            //   oosImgName: 'ai/ai_QGPaDJWg.png',
            //   oosUrl: 'https://img.kakaclo.com/ai/ai_QGPaDJWg.png',
            //   guid: guid()
            // },
            // {
            //   pngInfo: {
            //     seed: '111111111111111',
            //     size: '512x512',
            //     model: 'chilloutmix_NiPrunedFp32Fix',
            //     steps: null,
            //     sampler: 'Euler',
            //     version: 'v1.4.0',
            //     cfgScale: 7,
            //     modelHash: 'fc2511737a',
            //     seedResizeFrom: '-1x-1',
            //     denoisingStrength: 0.75
            //   },
            //   oosImgName: 'ai/ai_QGPaDJWg.png',
            //   oosUrl: 'https://img.kakaclo.com/ai/ai_QGPaDJWg.png',
            //   guid: guid()
            // }
          ]
        }
      ],
      historyList: [],
      aiTaskLength: 0,
      history: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        loading: false
      }
    }
  },
  computed: {
    firstName() {
      return this.$store.state.common.userName && this.$store.state.common.userName[0].toUpperCase()
    }
  },
  created() {
    sessionStorage.setItem('aiTaskList', JSON.stringify([]))
  },
  mounted() {
    this.initAi()
    this.$nextTick(() => {
      this.$refs.aiMain.addEventListener('scroll', this.scroll)
    })
  },
  beforeDestroy() {
    this.$refs.aiMain.removeEventListener('scroll', this.scroll)
  },
  methods: {
    handleChange() {},
    // 选择品类
    categoryChange(value) {
      this.categoryList.forEach(item => {
        if (item.value === value) {
          this.categorySel = item
        }
      })
    },
    uploadSuccess(imgUrl) {
      this.$set(this.param, 'initImages', imgUrl)
      this.isHistory = false
      let imgInfo = imgUrl + '?x-oss-process=image/info'
      axios({ url: imgInfo, method: 'get' }).then(res => {
        let width = +res.ImageWidth.value
        let height = +res.ImageHeight.value
        if (width >= height && width > 2048) {
          height = height / width * 2048
          width = 2048
        } else if (height >= width && height > 2048) {
          width = width / height * 2048
          height = 2048
        } else if (width <= height && width < 64) {
          height = height / width * 64
          width = 64
        } else if (height <= width && height < 64) {
          width = width / height * 64
          height = 64
        }
        this.param.width = Math.round(width)
        this.param.height = Math.round(height)
      })
    },
    initAi(type) {
      this.aiTaskList = sessionStorage.getItem('aiTaskList') ? JSON.parse(sessionStorage.getItem('aiTaskList')) : []
      if (type === 'back') this.isHistory = false
      else {
        this.aiTaskLength = this.aiTaskList.length + 1
        this.aiWaitingOrProgress()
      }
    },
    // 查询是否有排的与正在生成的任务
    aiWaitingOrProgress() {
      API.aiWaitingOrProgress().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (res.data.length) this.aiCustomImgStatus(res.data[0])
      })
    },
    // 发送 生成图片
    generate() {
      let param = _.cloneDeep(this.param)
      param.denoisingStrength = this.denoisingStrength / 100
      param.seed = this.seed
      param.batchSize = this.imageCount
      let prompt = ''
      if (!param.initImages) return this.$message.warning('Please upload an image')
      if (!this.categoryVal) return this.$message.warning('Please select a category')
      if (this.categoryVal) prompt += this.categoryVal + ','
      this.prompt01.forEach(item => {
        if (item.value) prompt += item.value + ','
      })
      if (this.prompt02) prompt += this.prompt02
      if (prompt.charAt(prompt.length - 1) === ',') prompt = prompt.substring(0, prompt.length - 1)
      param.prompt = prompt
      this.isRequest = true
      API.aiCustomImg(param).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.aiCustomImgStatus(res.data)
      })
    },
    // ai任务状态
    aiCustomImgStatus(taskId) {
      if (this.isCancelTask) {
        this.isCancelTask = false
        return
      }
      API.aiCustomImgStatus({ taskId }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.isRequest = true
        this.aiData = res.data
        let taskObj = {
          taskId: res.data.taskId,
          status: res.data.status,
          progress: Math.floor((res.data.progress || 0) * 100), // 等待中 的进度
          queue: res.data.queue, // '排队人数'
          estimateTime: res.data.estimateTime, // 预估剩余排队时间s
          parameters: res.data.result.parameters,
          images: res.data.result.images || []
        }
        if (!taskObj.images.length) {
          for (let i = 0; i < taskObj.parameters.batchSize; i++) {
            taskObj.images.push({})
          }
        }
        let aiTaskList = this.aiTaskList
        if (res.data.status !== 'In Complete' && res.data.status !== 'IN INTERRUPT') {
          if (this.aiTaskLength > aiTaskList.length) aiTaskList.unshift(taskObj)
          else aiTaskList[0] = taskObj
          timer = setTimeout(() => {
            this.aiCustomImgStatus(taskId)
          }, 2000)
        } else {
          aiTaskList[0] = taskObj
          this.aiTaskLength++
        }
        this.aiTaskList = aiTaskList
        sessionStorage.setItem('aiTaskList', JSON.stringify(this.aiTaskList))
      }).catch(() => {
        timer = setTimeout(() => {
          this.aiCustomImgStatus(taskId)
        }, 2000)
      })
    },
    // 获取历史ai任务
    handleHistory() {
      this.isHistory = true
      API.aiCustomImgList({
        pageNumber: this.history.pageNumber,
        pageSize: this.history.pageSize
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.history.total = res.data.total
        this.historyList = this.history.pageNumber === 1 ? res.data.list : [...this.historyList, ...res.data.list]
      }).finally(() => {
        this.history.loading = false
      })
    },
    scroll: _.debounce(function() {
      if (!this.isHistory) return
      var scrollTop = this.$refs.aiMain.scrollTop
      var windowHeight = this.$refs.aiMain.clientHeight
      var scrollHeight = this.$refs.aiMain.scrollHeight
      if (scrollTop + windowHeight - scrollHeight > -500) {
        this.history.loading = true
        if (this.historyList.length < this.history.total) {
          this.$nextTick(() => {
            this.history.pageNumber++
            this.handleHistory()
          })
        }
      }
    }, 500, { leading: false, trailing: true }),
    // 删除任务或图片
    handleDelete(param) {
      API.aiCustomImgSet(param).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        let historyIdx = this.historyList.findIndex(item => item.taskId === param.taskId)
        let aiTaskIdx = this.aiTaskList.findIndex(item => item.taskId === param.taskId)
        if (param.type === 'all') {
          this.renewal('delete', param.taskId)
        } else {
          let historyList = _.cloneDeep(this.historyList)
          let aiTaskList = _.cloneDeep(this.aiTaskList)
          if (historyIdx >= 0) {
            historyList[historyIdx].images = _.cloneDeep(param.images)
            console.log(111, historyList, this.historyList)
            this.historyList = historyList
          }
          if (aiTaskIdx >= 0) {
            aiTaskList[aiTaskIdx].images = _.cloneDeep(param.images)
            console.log(222, aiTaskList, this.aiTaskList)
            this.aiTaskList = aiTaskList
          }
          this.renewal('set')
        }
      })
    },
    // 取消生成任务
    handleCancel(taskId) {
      this.aiTaskLength++
      this.isCancelTask = true
      timer = null
      this.renewal('delete', taskId)
    },
    // 跳转
    jump() {
      this.$router.push('/')
    },
    // 更新任务列表
    renewal(type, taskId) {
      if (type === 'delete') {
        let historyIdx = this.historyList.findIndex(item => item.taskId === taskId)
        let aiTaskIdx = this.aiTaskList.findIndex(item => item.taskId === taskId)
        let historyList = _.cloneDeep(this.historyList)
        let aiTaskList = _.cloneDeep(this.aiTaskList)
        if (historyIdx >= 0) {
          historyList.splice(historyIdx, 1)
          this.historyList = historyList
          this.history.total--
        }
        if (aiTaskIdx >= 0) {
          aiTaskList.splice(aiTaskIdx, 1)
          this.aiTaskList = aiTaskList
          this.aiTaskLength--
        }
      }
      sessionStorage.setItem('aiTaskList', JSON.stringify(this.aiTaskList))
      this.isRequest = false
    },
    handleInput() {
      let seed = this.seed
      seed = seed.replace(/[^\d]/g, '')
      this.seed = seed
    }
  }
}
</script>

<style lang="scss" scoped>
.ai {
  min-width: 1200px;
  height: 100vh;
  overflow: hidden;

  header {
    height: 64px;
    border-bottom: 1px solid #EFF1F7;
    padding: 0 20px;

    .left {
      .logo {
        height: 40px;
      }
      .logo-ai {
        height: 32px;
        margin-left: 13px;
        padding-left: 13px;
        border-left: 1px solid #EFF1F7;
      }
      img {
        height: 100%;
      }
    }

    .right {
      .time, .warning {
        width: 24px;
        height: 24px;
        margin-left: 20px;
      }
      .user {
        margin-left: 20px;
        padding-right: 10px;

        .avatar {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: #9AC331;
          color: #fff;
        }
        .name {
          color: #606266;
          font-size: 14px;
          margin-left: 4px;
        }
      }
    }
  }

  .content {
    height: calc(100vh - 64px);
    animation: all .3;

    .filtration-options {
      width: 360px;
      height: 100%;
      border-right: 1px solid #EFF1F7;
      position: relative;
      padding-bottom: 90px;

      .slider {
        overflow: auto;
        height: 100%;
        padding-bottom: 10px;
      }

      .options {
        padding: 12px 20px;
        border-bottom: 1px solid #EFF1F7;

        .head {
          .title {
            position: relative;
            >i {
              position: absolute;
              left: -10px;
              color: #F36D6F;
            }
          }
        }
        .block {
          padding-top: 10px;

          /deep/ .el-radio-group {
            display: flex;
            flex-wrap: wrap;

            .el-radio {
              margin: 0;
              margin-right: 10px;
              margin-bottom: 10px;
              &:last-child{
                margin-bottom: 0;
              }
            }
          }

          .img{
            width: 100%;
            height: 320px;
            border-radius: 4px;
            border: 2px dotted #E1E4EA;
            background-color: #F7F8FB;
            overflow: hidden;

            img {
              width: 320px;
              height: 320px;
              display: block;
            }

            .upload {
              color: #909399;
              >img {
                width: 40px;
                height: 40px;
              }
              >div {
                line-height: 24px;
                font-size: 14px;
              }
            }
          }

          .hint {
            margin-top: 8px;
            font-size: 12px;
          }

          .select {
            width: 100%;
            margin-bottom: 8px;
            /deep/ .el-input.el-input--suffix > .el-input__inner, .el-input > .el-input__inner {
              border-radius: 4px;
            }
          }
        }

        /deep/ .el-collapse-item__header {
          height: auto;
          line-height: unset;
          border-bottom: 0;
        }
        /deep/ .el-collapse-item__wrap {
          border-bottom: 0;
          .el-collapse-item__content {
            padding-bottom: 0
          }
        }

        /deep/ .input {
          padding-top: 8px;
          .el-input__inner {
            border-radius: 4px !important;
          }
        }
      }
      /deep/ .el-collapse {
        border-top: 0;
      }
      /deep/ .el-collapse-item {
        padding-right: 16px;
      }

      .options-foot {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        box-shadow: 0 -10px 10px #eee;

        .foot-btn {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

    }
    .main {
      flex: 1;
      width: 100%;
      max-width: unset;
      margin: 0;
      overflow: auto;

      .alert {
        height: 36px;
        background-color: #F7F8FB;
        position: relative;
        color: #909399;
        >div {
          font-weight: 400;
        }
        .el-icon-info {
          color: #909399;
          font-size: 17px;
          margin-right: 4px;
        }
        .el-icon-close {
          position: absolute;
          right: 20px;
          color: #C0C4CC;
        }
      }

      .main-img {
        height: calc(100vh - 64px);
      }

      .empty{
        margin-top: 20vh;
        flex-direction: column;
        font-size: 14px;
        img {
          width: 120px;
          height: 120px;
        }
        .btn {
          margin: 24px 0 8px 0;
        }
      }
    }
  }

  .gray {
    color: #909399;
  }
  .green {
    color: #9AC331;
    cursor: pointer;
  }

  @media screen and (max-width: 1200px) {
    height: calc(100vh - 10px);
  }
}
</style>
